import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2196c488"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "graph-wrap" }
const _hoisted_2 = ["onMouseover"]
const _hoisted_3 = { class: "value" }

import { computed } from "vue"

  
export default /*#__PURE__*/_defineComponent({
  props: {
    statValues: null,
    statIcon: null,
    deckCardCount: null
  },
  emits: ["hoverStat"],
  setup(__props: any) {

const props = __props as {
    statValues: number[]
    statIcon: string
    deckCardCount: number
  }

  

  // -1 required because the lowest possible stat value is 0
  const statMax = computed(() => props.statValues.length - 1)

  const statPercentWeights = computed(() => {
    // get weights -- count/all values
    const vals = props.statValues.map((el) => {
      let val = el / props.deckCardCount
      if (Number.isNaN(val)) {
        return 0
      } else {
        return val
      }
    })
    // adjust all weights to max=100 baseline
    let max = [...vals].sort()[vals.length - 1]
    let f = max ? 1 / max : 0
    const adjustedVals = vals.map((el) => (el * f * 100).toFixed(1))
    return adjustedVals
  })

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.statValues.keys(), (key) => {
        return (_openBlock(), _createElementBlock("li", {
          key: key,
          onMouseover: ($event: any) => (
          _ctx.$emit('hoverStat', key)
        )
        }, [
          _createElementVNode("div", {
            class: "bar",
            style: _normalizeStyle({ height: `${_unref(statPercentWeights)[key]}%` })
          }, null, 4),
          _createElementVNode("div", _hoisted_3, _toDisplayString(key === _unref(statMax) ? `${key}+` : key), 1)
        ], 40, _hoisted_2))
      }), 128))
    ]),
    _createElementVNode("i", {
      class: _normalizeClass(__props.statIcon)
    }, null, 2)
  ]))
}
}

})